import { defineStore } from "pinia";
import { leftMenu_actions, leftMenu_getters, leftMenu_state } from "./leftMenu";

export const useNavigationStore = defineStore("navigation", {
  state: () => Object.assign({}, leftMenu_state),
  actions: leftMenu_actions,
  getters: leftMenu_getters
});
